import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceTemplateLine  {
    _originalTypeClassName = "zERP.BO.InvoiceTemplateLine";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceTemplateLine.translate = translateService;
}
this.IncomeClassifications = [];
this.ExpensesClassifications = [];
this.ExpensesVATClassification = [];
this.Id = null;
this.Quantity = 1;
this.QuantityBinding = null;
this.Price = null;
this.Expanded = false;
this.HardCodedItem = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Quantity:any;
QuantityBinding:any;
Price:any;
Expanded:any;
HardCodedItem:any;
TransactionItem:any;
WithheldTaxCategory:any;
StampDutyTaxCategory:any;
FeesTaxCategory:any;
OtherTaxCategory:any;
DeductionTaxCategory:any;
VatCategory:any;
PriceBinding:any;
IncomeClassifications:any;
ExpensesClassifications:any;
BudgetItem:any;
CollectionBinding:any;
TransactionItemBinding:any;
ExpensesVATClassification:any;
static setTransactionItem = ($this, value) => {
var oldValue = $this.TransactionItem;
$this.TransactionItem = value;
if (value != null) {
}
}
static setWithheldTaxCategory = ($this, value) => {
var oldValue = $this.WithheldTaxCategory;
$this.WithheldTaxCategory = value;
if (value != null) {
}
}
static setStampDutyTaxCategory = ($this, value) => {
var oldValue = $this.StampDutyTaxCategory;
$this.StampDutyTaxCategory = value;
if (value != null) {
}
}
static setFeesTaxCategory = ($this, value) => {
var oldValue = $this.FeesTaxCategory;
$this.FeesTaxCategory = value;
if (value != null) {
}
}
static setOtherTaxCategory = ($this, value) => {
var oldValue = $this.OtherTaxCategory;
$this.OtherTaxCategory = value;
if (value != null) {
}
}
static setDeductionTaxCategory = ($this, value) => {
var oldValue = $this.DeductionTaxCategory;
$this.DeductionTaxCategory = value;
if (value != null) {
}
}
static setVatCategory = ($this, value) => {
var oldValue = $this.VatCategory;
$this.VatCategory = value;
if (value != null) {
}
}
static setPriceBinding = ($this, value) => {
var oldValue = $this.PriceBinding;
$this.PriceBinding = value;
if (value != null) {
}
}
static setIncomeClassifications = ($this, items) => {
                if (items == null) items = [];
                if ($this.IncomeClassifications == null) $this.IncomeClassifications = [];

                const copyItems = Common.cloneObject(items);

                while ($this.IncomeClassifications.length > 0) {
                    Domain.InvoiceTemplateLine.removeIncomeClassifications($this, $this.IncomeClassifications[0]);
                }

                Domain.InvoiceTemplateLine.addManyIncomeClassifications($this, copyItems);
            }
static addManyIncomeClassifications = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceTemplateLine.addIncomeClassifications($this, items[i]);
                }
            }
static addIncomeClassifications = ($this, item) => {
                if ($this.IncomeClassifications == null) $this.IncomeClassifications = [];
                if (item == null || $this.IncomeClassifications.indexOf(item) > -1) return;
                $this.IncomeClassifications.push(item);
}
static addRangeIncomeClassifications = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceTemplateLine.addIncomeClassifications($this, item));
            }
static removeIncomeClassifications = ($this, item) => {
                if ($this == null || $this.IncomeClassifications == null || $this.IncomeClassifications.indexOf(item) === -1) return;
                var _index = $this.IncomeClassifications.indexOf(item);
                $this.IncomeClassifications.splice(_index, 1);
}
static clearIncomeClassifications = ($this) => { $this.IncomeClassifications = null; }
static setExpensesClassifications = ($this, items) => {
                if (items == null) items = [];
                if ($this.ExpensesClassifications == null) $this.ExpensesClassifications = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ExpensesClassifications.length > 0) {
                    Domain.InvoiceTemplateLine.removeExpensesClassifications($this, $this.ExpensesClassifications[0]);
                }

                Domain.InvoiceTemplateLine.addManyExpensesClassifications($this, copyItems);
            }
static addManyExpensesClassifications = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceTemplateLine.addExpensesClassifications($this, items[i]);
                }
            }
static addExpensesClassifications = ($this, item) => {
                if ($this.ExpensesClassifications == null) $this.ExpensesClassifications = [];
                if (item == null || $this.ExpensesClassifications.indexOf(item) > -1) return;
                $this.ExpensesClassifications.push(item);
}
static addRangeExpensesClassifications = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceTemplateLine.addExpensesClassifications($this, item));
            }
static removeExpensesClassifications = ($this, item) => {
                if ($this == null || $this.ExpensesClassifications == null || $this.ExpensesClassifications.indexOf(item) === -1) return;
                var _index = $this.ExpensesClassifications.indexOf(item);
                $this.ExpensesClassifications.splice(_index, 1);
}
static clearExpensesClassifications = ($this) => { $this.ExpensesClassifications = null; }
static setBudgetItem = ($this, value) => {
var oldValue = $this.BudgetItem;
$this.BudgetItem = value;
if (value != null) {
}
}
static setCollectionBinding = ($this, value) => {
var oldValue = $this.CollectionBinding;
$this.CollectionBinding = value;
if (value != null) {
}
}
static setTransactionItemBinding = ($this, value) => {
var oldValue = $this.TransactionItemBinding;
$this.TransactionItemBinding = value;
if (value != null) {
}
}
static setExpensesVATClassification = ($this, items) => {
                if (items == null) items = [];
                if ($this.ExpensesVATClassification == null) $this.ExpensesVATClassification = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ExpensesVATClassification.length > 0) {
                    Domain.InvoiceTemplateLine.removeExpensesVATClassification($this, $this.ExpensesVATClassification[0]);
                }

                Domain.InvoiceTemplateLine.addManyExpensesVATClassification($this, copyItems);
            }
static addManyExpensesVATClassification = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceTemplateLine.addExpensesVATClassification($this, items[i]);
                }
            }
static addExpensesVATClassification = ($this, item) => {
                if ($this.ExpensesVATClassification == null) $this.ExpensesVATClassification = [];
                if (item == null || $this.ExpensesVATClassification.indexOf(item) > -1) return;
                $this.ExpensesVATClassification.push(item);
}
static addRangeExpensesVATClassification = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceTemplateLine.addExpensesVATClassification($this, item));
            }
static removeExpensesVATClassification = ($this, item) => {
                if ($this == null || $this.ExpensesVATClassification == null || $this.ExpensesVATClassification.indexOf(item) === -1) return;
                var _index = $this.ExpensesVATClassification.indexOf(item);
                $this.ExpensesVATClassification.splice(_index, 1);
}
static clearExpensesVATClassification = ($this) => { $this.ExpensesVATClassification = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}